import Sidebar from "@/components/sidebar/Sidebar";
import { ScrollArea } from "@/components/ui/scroll-area";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_fixed-sidebar")({
  component: FixedSidebar
});

function FixedSidebar() {
  return (
    <div className="flex w-full">
      <div className="m-1.5 mr-0">
        <Sidebar />
      </div>

      <ScrollArea className="relative dark:bg-brand-gray-950 bg-white w-full m-1.5 rounded-lg dark:border dark:border-brand-gray-900">
        <div
          className="max-w-[90rem] flex justify-center w-full h-full mx-auto py-4 px-6"
          style={{ minHeight: "calc(100vh - 14px)" }}
        >
          <Outlet />
        </div>
      </ScrollArea>
    </div>
  );
}
